import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import type { TypedUseQueryHookResult } from "@reduxjs/toolkit/query/react";

import type {
  BudgetSummaryDto,
  GetBudgetSummaryArgs,
} from "@/@types/price-markdown-budget";
import type {
  GetIndicatorsArgs,
  IndicatorsResponseDto,
} from "@/@types/price-markdown-indicators";
import { Tags } from "@/enum/tags";
import { apiSlice } from "@/services/http";

export type IndicatorsQuery = TypedUseQueryHookResult<
  IndicatorsResponseDto,
  GetIndicatorsArgs,
  BaseQueryFn
>;

export const priceMarkdownIndicatorsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBudgetSummary: builder.query<BudgetSummaryDto, GetBudgetSummaryArgs>({
      query: ({ markdownId }) => ({
        url: `/price-markdown/selection/drill/${markdownId}/budget-summary`,
        method: "GET",
      }),
      providesTags: (_result, _error, { markdownId }) => [
        { type: Tags.PRICE_MARKDOWN_VERBA_SUMMARY, id: markdownId },
        Tags.PRICE_MARKDOWN_VERBA_SUMMARY,
      ],
    }),

    getIndicators: builder.query<IndicatorsResponseDto, GetIndicatorsArgs>({
      query: ({ markdownId }) => ({
        url: `/price-markdown/selection/drill/${markdownId}/indicators`,
        method: "GET",
      }),
      providesTags: (_result, _error, { markdownId }) => [
        { type: Tags.PRICE_MARKDOWN_INDICADORES, id: markdownId },
        Tags.PRICE_MARKDOWN_INDICADORES,
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetBudgetSummaryQuery, useGetIndicatorsQuery } =
  priceMarkdownIndicatorsApi;
